module.exports = __webpack_public_path__ + "static/active-barre-20223-6f03dad43a009e9abb467b8fadd6c86e.jpg";